import loadingImage from '../../assets/loadingImage.gif'

function Loading() {
  return (
    <>
        <img src={loadingImage} width='100%' height='100%' alt="loading..." />
    </>
  )
}

export default Loading